import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Terminos() {
  const navigate = useNavigate();
  const updated = '1 de marzo de 2026';

  useEffect(() => {
    const html = document.documentElement;
    const prev = html.className;
    html.classList.add('dark');
    return () => { html.className = prev; };
  }, []);

  return (
    <div className="min-h-screen bg-gray-950 text-white">
      <nav className="border-b border-white/5 px-6 py-4">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <img
            src="/logorentiacompletonaranjablanco.png"
            alt="Rentia"
            className="h-8 w-auto object-contain cursor-pointer"
            onClick={() => navigate('/')}
          />
          <button onClick={() => navigate(-1)} className="text-gray-400 hover:text-white text-sm transition-colors">
            ← Volver
          </button>
        </div>
      </nav>

      <main className="max-w-4xl mx-auto px-6 py-16">
        <h1 className="text-3xl font-bold mb-2">Términos y Condiciones</h1>
        <p className="text-gray-400 text-sm mb-12">Última actualización: {updated}</p>

        <div className="space-y-10 leading-relaxed">

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">1. Aceptación de los términos</h2>
            <p>
              Al acceder y utilizar la plataforma Rentia, disponible en{' '}
              <span className="text-[#ed6f28]">rentiapropiedades.com</span>, el usuario acepta quedar vinculado por
              los presentes Términos y Condiciones. Si no está de acuerdo con alguna de estas condiciones,
              deberá abstenerse de utilizar el servicio.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">2. Descripción del servicio</h2>
            <p>
              Rentia es una plataforma de software como servicio (SaaS) diseñada para la administración de
              propiedades en alquiler en la República Argentina. Permite gestionar contratos, registrar pagos,
              calcular actualizaciones según índices oficiales (ICL/IPC), generar reportes y emitir comprobantes.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">3. Registro y cuenta de usuario</h2>
            <p>
              Para acceder al servicio, el usuario debe crear una cuenta con información veraz y actualizada.
              Es responsable de mantener la confidencialidad de sus credenciales y de todas las actividades
              realizadas bajo su cuenta. Rentia no será responsable por pérdidas derivadas del uso no autorizado
              de la cuenta por parte de terceros.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">4. Planes y facturación</h2>
            <p>
              Rentia ofrece un período de prueba gratuito de 60 días con acceso completo al servicio. Transcurrido
              dicho período, la continuidad del servicio requiere la contratación de uno de los planes disponibles:
            </p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-white">
              <li><strong className="text-gray-100">Plan Mensual:</strong> $35.000 ARS / mes</li>
              <li><strong className="text-gray-100">Plan Semestral:</strong> $180.000 ARS / 6 meses</li>
              <li><strong className="text-gray-100">Plan Anual:</strong> $330.000 ARS / año</li>
            </ul>
            <p className="mt-3">
              Los precios están expresados en pesos argentinos e incluyen IVA. Rentia se reserva el derecho de
              modificar los precios con un preaviso mínimo de 30 días corridos comunicado por correo electrónico.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">5. Cancelación y reembolsos</h2>
            <p>
              El usuario puede cancelar su suscripción en cualquier momento. En caso de cancelación anticipada
              de un plan prepago, no se realizarán reembolsos por el período no utilizado. El servicio
              permanecerá activo hasta el vencimiento del período abonado.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">6. Uso aceptable</h2>
            <p>El usuario se compromete a utilizar el servicio exclusivamente para fines lícitos y a no:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-white">
              <li>Cargar información falsa, fraudulenta o que infrinja derechos de terceros.</li>
              <li>Intentar acceder a cuentas o datos de otros usuarios.</li>
              <li>Utilizar el servicio para actividades contrarias a la legislación argentina vigente.</li>
              <li>Realizar ingeniería inversa, descompilar o reproducir el software.</li>
            </ul>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">7. Propiedad intelectual</h2>
            <p>
              Todos los derechos sobre el software, diseño, marcas, logotipos y contenido de Rentia son
              propiedad exclusiva de sus titulares. El acceso al servicio no otorga al usuario ningún derecho
              de propiedad sobre dichos elementos.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">8. Limitación de responsabilidad</h2>
            <p>
              Rentia proporciona el servicio "tal como está". No garantiza que el servicio sea ininterrumpido
              o libre de errores. En ningún caso Rentia será responsable por daños indirectos, incidentales
              o consecuentes derivados del uso o la imposibilidad de uso del servicio.
            </p>
            <p className="mt-3">
              Los índices ICL e IPC son obtenidos de fuentes oficiales (BCRA e INDEC). Rentia no garantiza
              la exactitud de dichos datos y no es responsable por errores en los cálculos derivados de
              información incorrecta publicada por los organismos oficiales.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">9. Modificaciones al servicio</h2>
            <p>
              Rentia se reserva el derecho de modificar, suspender o discontinuar el servicio en cualquier
              momento, con o sin previo aviso. Asimismo, estos Términos pueden ser actualizados periódicamente.
              La continuación del uso del servicio tras la publicación de cambios implica la aceptación
              de los nuevos términos.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">10. Jurisdicción y ley aplicable</h2>
            <p>
              El presente acuerdo se rige por las leyes de la República Argentina. Cualquier controversia
              que surja en relación con estos términos será sometida a la jurisdicción de los tribunales
              ordinarios de la Ciudad Autónoma de Buenos Aires, con renuncia expresa a cualquier otro fuero.
            </p>
          </section>

          <section className="text-white">
            <h2 className="text-xl font-semibold text-white mb-3">11. Contacto</h2>
            <p>
              Para consultas relacionadas con estos Términos y Condiciones, puede comunicarse a:{' '}
              <a href="mailto:soporte@rentiapropiedades.com" className="text-[#ed6f28] hover:underline">
                soporte@rentiapropiedades.com
              </a>
            </p>
          </section>

        </div>
      </main>

      <footer className="border-t border-white/5 px-6 py-6 text-center text-gray-600 text-xs">
        © {new Date().getFullYear()} Rentia · Todos los derechos reservados
      </footer>
    </div>
  );
}
